var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ContactAnswers text-xs items-center"},[_c('div',{staticClass:"flex flex-wrap items-center justify-center"},_vm._l(((_vm.answers || []).slice(0, 8)),function(ref){
var key = ref[0];
var val = ref[1];
var preIcon = ref[2];
var postIcon = ref[3];
return _c('a-tooltip',{key:key,attrs:{"title":key}},[_c('Pill',{attrs:{"tight":""}},[(preIcon)?_c('Icon',{staticClass:"inline-icon",attrs:{"name":preIcon}}):_vm._e(),_vm._v(" "+_vm._s(val)+" "),(postIcon)?_c('Icon',{staticClass:"inline-icon",attrs:{"name":postIcon}}):_vm._e()],1)],1)}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }